import { sortFolders } from '../service/folderService'
import { getUserInfo, getBaseSet } from '../service/homeService'
import { getWriteContact } from '@/service/contactService'
import * as type from './mutation-types.js'

const actions = {
    async getFolders ({
        commit,
        state
    }) {
        let response = await sortFolders()
        response && commit(type.GET_FOLDERS, response)
    },
    async getUserInfo ({
        commit,
        state
    }) {
        let response = await getUserInfo()
        if (response) {
            commit(type.GET_USERINFO, response)
            let column = localStorage.getItem(response.email + '_column') !== 'false'
            commit(type.SET_COLUMN, column)
            // 隐藏会话功能
            // let dialog = localStorage.getItem(response.email + '_dialog') !== 'false'
            // commit(type.SET_DIALOG, dialog)
        }
    },
    async getBaseSet ({
        commit,
        state
    }) {
        let response = await getBaseSet()
        response && commit(type.SAVE_BASESET, response)
    },
    async getContact ({
        commit,
        state
    }) {
        let response = await getWriteContact()
        response && commit(type.GET_CONTACT_LIST, response)
    }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js